import type { ReceiptTemplate } from '../schema';

export const zelleTemplate: ReceiptTemplate = {
  id: 'zelle',
  name: 'Zelle Receipt',
  brand: 'ZELLE',
  description: 'Zelle payment receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'zl-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'ZELLE',
        businessNameFontSize: 24,
        addressLines: ['PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zl-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'from', label: 'From:', value: 'John Doe' },
          { id: 'to', label: 'To:', value: 'Mike Wazowski' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'zl-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'amount', label: 'AMOUNT', value: '150.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'zl-details',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'MEMO: Rent payment\nCONF #: ZL847291034\nSTATUS: COMPLETED', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'zl-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SENT', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

